import { render, staticRenderFns } from "./priceLinkageDialog.vue?vue&type=template&id=03fc1fb2&scoped=true"
import script from "./priceLinkageDialog.vue?vue&type=script&lang=js"
export * from "./priceLinkageDialog.vue?vue&type=script&lang=js"
import style0 from "./priceLinkageDialog.vue?vue&type=style&index=0&id=03fc1fb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fc1fb2",
  null
  
)

export default component.exports